<div class="tracking-container" *ngIf="modo==='normal'">
  <header class="tracking-header">
    <div class="header-content">
      <button class="back-btn" (click)="backToHistorial()" title="Volver al historial">
        <span class="mdi mdi-arrow-left"></span>
      </button>
      <div class="order-title">
        <span class="label">Pedido</span>
        <span class="order-id">#{{historia.idPedido}}</span>
        <span class="separator">-</span>
        <span class="order-date">{{historia.fecha}}</span>
      </div>
    </div>
  </header>

  <main class="tracking-main">
    <section class="progress-section card glass">
      <estados-traking-mmax></estados-traking-mmax>
    </section>

    <div class="details-grid">
      <section class="info-section card glass">
        <div class="card-header">
          <span class="mdi mdi-information-outline"></span>
          <h3>Información de {{retiroEnvio}}</h3>
        </div>

        <div class="info-list" *ngIf="usaTurnos == 'S'; else noUsaTurnos">
          <div class="info-item">
            <span class="mdi mdi-calendar-range"></span>
            <div class="item-content">
              <span class="item-label">Fecha</span>
              <span class="item-value">{{turno.dia}}</span>
            </div>
          </div>
          <div class="info-item">
            <span class="mdi mdi-clock-outline"></span>
            <div class="item-content">
              <span class="item-label">Hora</span>
              <span class="item-value">{{turno.hora}} hs</span>
            </div>
          </div>
          <div class="info-item">
            <span class="mdi mdi-map-marker-outline"></span>
            <div class="item-content">
              <span class="item-label">Dirección</span>
              <span class="item-value">{{direccionPedido}}</span>
            </div>
          </div>
        </div>

        <ng-template #noUsaTurnos>
          <div class="info-list">
            <div class="info-item">
              <span class="mdi mdi-clock-fast"></span>
              <div class="item-content">
                <span class="item-label">Plazo Estimado</span>
                <span class="item-value">Pasadas las {{horasMinimasTurno}}hs a partir del día {{historia.fecha}}</span>
              </div>
            </div>
            <div class="info-item">
              <span class="mdi mdi-map-marker-outline"></span>
              <div class="item-content">
                <span class="item-label">Dirección</span>
                <span class="item-value">{{direccionPedido}}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </section>

      <section class="products-section card glass">
        <div class="card-header">
          <span class="mdi mdi-basket-outline"></span>
          <h3>Productos del Pedido</h3>
        </div>
        <div class="products-list-wrapper">
          <lista-productos-view [modelo]="'historialDetail'" [articulosIn]="articulos"></lista-productos-view>
        </div>
      </section>

      <section class="summary-section card glass">
        <div class="card-header">
          <span class="mdi mdi-receipt-text-outline"></span>
          <h3>Resumen del Pago</h3>
        </div>

        <div class="summary-content">
          <div *ngIf="!ocultarPrecios" class="totals-list">
            <div class="total-row" *ngIf="costoFlete">
              <span>Subtotal</span>
              <span>{{historia.monto - costoFlete | currency }}</span>
            </div>
            <div class="total-row" *ngIf="costoFlete">
              <span>Costo de Envío</span>
              <span>+{{costoFlete | currency}}</span>
            </div>
            <div class="total-row grand-total">
              <span>TOTAL</span>
              <span>{{historia.monto | currency}}</span>
            </div>
          </div>

          <button *ngIf="displayFactura === 'flex'" class="factura-btn" (click)="verFactura()">
            <span class="mdi mdi-file-pdf-box"></span>
            Ver Factura
          </button>
        </div>
      </section>
    </div>
  </main>
</div>